import type { SkinPickerCarouselSkin } from "../../pages/Whitelabel/SkinPickerCarousel";
import type { WhitelabelPackageCard } from "../../pages/Whitelabel/WhitelabelPackagePicker";

const img = (path: string) => path;

/** Replace with production-like data when ready; no API calls. */
export const GUIDE_WL_BRAND_NAME = "DemoBrand";

export const GUIDE_WL_SUBDOMAIN = "demobrand";

export const GUIDE_WL_DOMAIN_SUFFIX = "example.com";

export const GUIDE_WL_SKINS: SkinPickerCarouselSkin[] = [
  {
    skinId: "SKN_cvJw",
    name: "strike",
    logo: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Logo/SKN_cvJw.svg",
    previewImages: [
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/Screenshot 2026-04-16 145927.png",
        name: "Home",
      },
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/Screenshot 2026-04-16 145952.png",
        name: "Casino",
      },
    ],
    siteUrl: "https://demo.strike46.com",
    tglink: "https://t.me/yapot_bot",
    weblink: "https://demo.strike46.com",
  },
  {
    skinId: "SKN_crOW",
    name: "fantasy",
    logo: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Logo/SKN_crOW.png",
    previewImages: [
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/fh-home.png",
        name: "Home",
      },
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/fh-exch.png",
        name: "Exchange",
      },
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/fh-casino.png",
        name: "Casino",
      },
    ],
    siteUrl: "https://stage.fantasyhub.vip",
    tglink: "https://t.me/fhstage_bot",
    weblink: "https://stage.fantasyhub.vip",
  },
  {
    skinId: "SKN_Oz3A",
    name: "matka",
    logo: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Logo/SKN_Oz3A_1776676708222238176.png",
    previewImages: [
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/Matkafun.png",
        name: "Matkafun",
      },
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/Matka Live.png",
        name: "Matka Live",
      },
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/Wallet.png",
        name: "Wallet",
      },
      {
        url: "https://stage-cdn.stwin2025.co/TG/BotYaPot/Skins/Previews/Settings.png",
        name: "Settings",
      },
    ],
    siteUrl: "https://stage-matka.strike46.com",
    tglink: "https://t.me/matkademobot",
    weblink: "https://stage-matka.strike46.com",
  },
];

export type GuideWlCategory = { key: string; label: string };

export const GUIDE_WL_CATEGORIES: GuideWlCategory[] = [
  { key: "sports", label: "Sports" },
  { key: "casino", label: "Casino" },
  { key: "matka", label: "Matka" },
  { key: "fantasy", label: "Fantasy" },
];

export type GuideWlThemeCard = {
  name: string;
  primary: string;
  secondary: string;
  background: string;
  imageUrls: [string, string, string];
};

export type GuideWlThemeCategory = {
  category: string;
  themes: GuideWlThemeCard[];
};

export const GUIDE_WL_THEME_CONFIGS: GuideWlThemeCategory[] = [
  {
    category: "Classic",
    themes: [
      {
        name: "Ocean",
        primary: "#0ea5e9",
        secondary: "#0369a1",
        background: "#0c1220",
        imageUrls: [img("/pg-logo.svg"), img("/pg-logo.svg"), img("/pg-logo.svg")],
      },
      {
        name: "Sunset",
        primary: "#f97316",
        secondary: "#c2410c",
        background: "#1a0a06",
        imageUrls: [img("/pg-logo.svg"), img("/pg-logo.svg"), img("/pg-logo.svg")],
      },
    ],
  },
  {
    category: "Bold",
    themes: [
      {
        name: "Neon",
        primary: "#a855f7",
        secondary: "#7c3aed",
        background: "#0f0518",
        imageUrls: [img("/pg-logo.svg"), img("/pg-logo.svg"), img("/pg-logo.svg")],
      },
    ],
  },
];

export const GUIDE_WL_PACKAGES: WhitelabelPackageCard[] = [
  {
    packageId: "guide-pkg-starter",
    name: "Starter",
    pointsCredited: 5000,
    payAmount: 499,
    currency: "INR",
    paymentMethods: ["FIAT", "CRYPTO"],
  },
  {
    packageId: "guide-pkg-pro",
    name: "Pro",
    pointsCredited: 15000,
    payAmount: 1299,
    originalPayAmount: 1499,
    currency: "INR",
    packageDiscountPercent: 13,
    paymentMethods: ["FIAT"],
  },
];
